import { render, staticRenderFns } from "./ClassifiedControls.vue?vue&type=template&id=609ed713&scoped=true&"
import script from "./ClassifiedControls.vue?vue&type=script&lang=js&"
export * from "./ClassifiedControls.vue?vue&type=script&lang=js&"
import style0 from "./ClassifiedControls.vue?vue&type=style&index=0&id=609ed713&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609ed713",
  null
  
)

export default component.exports